import UserProfile from '../Views/UserProfile/UserProfile';
import ResetPassword from '../Views/PasswordReset/ResetPassword';
import Maintenance from '../Views/Maintainance/Maintenance';
import MyBooking from '../Views/MyBooking/MyBooking';
import ReportIssue from '../Views/Reports/ReportIssue';
import Notification from '../Views/Nofitications/Notification';
import Logout from '../Views/Onboarding/logout';
import VerifyEmail from '../Views/Verify/VerifyEmail';
import VerifyPhone from '../Views/Verify/VerifyPhone';
import Home from '../Views/HomeScreen/Home.js';
import AddVehicle from '../Views/Vehicles/AddVehicle';
import VehicleList from '../Views/Vehicles/VehicleList';
import ShowSubscription from '../Views/Subscription/ShowSubscription';
import ListCards from '../Views/CardDetails/ListCards';
import AddCard from '../Views/CardDetails/AddCard';
import EditCard from '../Views/CardDetails/EditCard';

import Login from '../Views/Onboarding/Login'
import SignUp from '../Views/Onboarding/SignUp';
import ResetPasswordwithoutLogin from '../Views/PasswordReset/ResetPasswordwithoutLogin';
import VerifyEmailBeforeLogin from '../Views/Verify/VerifyEmailBeforeLogin';
import VerifyPhoneBeforeLogin from '../Views/Verify/VerifyPhoneBeforeLogin';
import ForgetPassword from '../Views/PasswordReset/ForgetPassword'
import EditProfile from '../Views/UserProfile/EditProfile';
import ChangePassword from '../Views/UserProfile/ChangePassword';
import VerifyRPO from '../Views/PasswordReset/VerifyRPO';

export const RoutesAfterLogin = [
    {
        path:`/verifyEmail`,
        component: VerifyEmail
    },
    {
        path:`/home`,
        component: Home
    },
    {
        path: `/verifyPhone`,
        component: VerifyPhone
    },
    {
        path: `/logout`,
        component: Logout
    },
    {
        path: `/resetPassword`,
        component: ResetPassword
    },
    {
        path: `/profile`,
        component: UserProfile
    },
    {
        path: `/maintainance`,
        component: Maintenance
    },
    {
        path: `/myBooking`,
        component: MyBooking
    },
    {
        path: `/report`,
        component: ReportIssue
    },
    {
        path: `/notification`,
        component: Notification
    },
    {
        path: `/booking/vehicleList/:id`,
        component: VehicleList
    },
    {
        path: `/booking/addVehicle/:id`,
        component: AddVehicle
    },
    {
        path: `/booking/listSubscription/:id/:id`,
        component: ShowSubscription
    },
    {
        path: `/booking/listCards/:id/:id/:id`,
        component: ListCards
    },
    {
        path: `/booking/listCards/addCard/:id/:id/:id`,
        component: AddCard
    },
    {
        path: `/profile/vehicleList`,
        component: VehicleList
    },
    {
        path: `/profile/vehicleList/addVehicle`,
        component: AddVehicle
    },
    {
        path: `/profile/cardList`,
        component: ListCards
    },
    {
        path: `/profile/cardList/addCard`,
        component: AddCard
    },
    {
        path: `/profile/cardList/editCard/:id`,
        component: EditCard
    },
    {
        path: `/profile/editProfile`,
        component: EditProfile
    },
    {
        path: `/profile/changePassword`,
        component: ChangePassword
    }
]


export const RoutesBeforeLogin = [
    {
        path: `/login`,
        component: Login
    },
    {
        path: `/signUp`,
        component: SignUp
    },
    {
        path: `/verifyEm`,
        component: VerifyEmailBeforeLogin
    },
    {
        path: `/verifyPh`,
        component: VerifyPhoneBeforeLogin
    },
    {
        path: `/ForgetPassword`,
        component: ForgetPassword
    },
    {
        path: `/verifyRPO`,
        component: VerifyRPO
    },
    {
        path: `/resetPass`,
        component: ResetPasswordwithoutLogin
    },
]